import { fetchResource } from '@platform/core/src/services/resourceApi';
import { applyPatch, deepClone } from 'fast-json-patch';

const transformLocation = (resource) => {
  if (!resource) return null;
  return {
    ...resource,
    type: 'location',
    resource_type: 'location',
  };
};

// Helper needs to check map now
const fetchMissingEquipment = async (currentMap, location) => {
  if (!location || !location.feature_ids || !Array.isArray(location.feature_ids)) {
    return [];
  }
  const missingIds = location.feature_ids.filter(id => !currentMap[id]);
  if (missingIds.length === 0) return [];
  
  const fetchedResources = await Promise.all(missingIds.map(async (id) => {
    try {
      const feature = await fetchResource('location_feature', id);
      if (feature) {
        return {
          ...feature,
          type: 'equipment',
          resource_type: 'equipment',
        };
      }
    } catch (e) {}
    return null;
  }));
  return fetchedResources.filter(Boolean);
};

const locationSyncDriver = {
  async handleCreated(currentMap, content) {
    try {
      const newResource = await fetchResource(content.resource_type, content.resource_id);
      if (!newResource) return currentMap;
      
      const transformedResource = transformLocation(newResource);
      const newEquipment = await fetchMissingEquipment(currentMap, transformedResource);
      
      const newMap = { ...currentMap, [content.resource_id]: transformedResource };
      newEquipment.forEach(eq => { newMap[eq.id] = eq; });
      
      return newMap;
    } catch (error) {
      return currentMap;
    }
  },
  async handleUpdated(currentMap, content) {
    if (!content.value) return currentMap;
    const transformedValue = transformLocation(content.value);
    const newEquipment = await fetchMissingEquipment(currentMap, transformedValue);
    
    const newMap = { ...currentMap, [content.resource_id]: transformedValue };
    newEquipment.forEach(eq => { newMap[eq.id] = eq; });
    
    return newMap;
  },
  async handlePatched(currentMap, content) {
    const resourceToPatch = currentMap[content.resource_id];
    if (!resourceToPatch) return this.handleCreated(currentMap, content);
    
    try {
      const patchedResource = applyPatch(deepClone(resourceToPatch), content.patches, true, false).newDocument;
      const transformedResource = transformLocation(patchedResource);
      const newEquipment = await fetchMissingEquipment(currentMap, transformedResource);
      
      const newMap = { ...currentMap, [content.resource_id]: transformedResource };
      newEquipment.forEach(eq => { newMap[eq.id] = eq; });
      
      return newMap;
    } catch (e) {
      return this.handleCreated(currentMap, content);
    }
  },
};
export default locationSyncDriver;